import styled from 'styled-components'

export const PageContent = styled.div`
  min-height: calc(100vh - 580px);
  .suggestion-link {
    color: blue;
    cursor: pointer;
    margin-right: 12px;
    a:hover {
      background-color: white;
      color: blue;
    }
  }
`

export const NoResultsWrapper = styled.div`
  padding: 30px;
  border-radius: 15px;
  margin-top: 25px;
  font-size: 17px;
`

export const HeadContainer = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: flex-start;
  gap: 5px;
  margin-bottom: 16px;

  h1 {
    font-family: var(--font-bold);
  }
`

export const ResultsWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  position: relative;
  font-weight: var(--font-regular);

  @media (max-width: 500px) {
    flex-wrap: wrap;
    row-gap: 20px;

    button {
      width: 100%;
    }
  }
`

export const FilterButtonContainer = styled.div`
  display: flex;
  gap: 24px;
  align-items: center;
  width: 100%;
`

export const FilterButton = styled.div`
  padding: 12px 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  line-height: 1;
  color: var(--text-primary);
  border: 2px solid var(--accent-primary);
  border-radius: 24px;
  font-size: 16px;
  font-weight: 600;
  svg {
    width: 24px;
    height: 24px;
  }
  span {
    margin-left: 6px;
  }
`

export const ResultsWrapperLeft = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
`

export const ListingContainer = styled.div<{ active: boolean }>`
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  transition: 0.3s ease-in-out;
  gap: 25px;
  position: relative;
  padding-left: 0;
  min-height: 700px;

  @media (max-width: 768px) {
    min-height: 100px;
  }

  ${({ active }) =>
    active &&
    `
    @media (min-width: 769px) {
      padding-left: 270px;
      
      .product-tile__image {
        height: 184px;
      }
      .product-tile__badges {
        top: 170px;
      }
      .product-tile__hot-deal {
        top: 158px;
      }
      .product-tile:nth-child(10n - 1), .product-tile:nth-child(10n) {
        grid-column-end: span 1;

        .product-tile__image {
          height: inherit;
        }
      }
    }
    
    @media (min-width: 1201px) and (max-width: 1350px) {
      > .listing-grid {
        grid-template-columns: repeat(3,minmax(0,calc(100% / 3)));
      }
    }
    
    @media (min-width: 769px) and (max-width: 1200px) {
      padding-left: 220px;
    }
  `}
`
export const ProductListContainer = styled.div`
  z-index: 1;
  position: relative;
  background-color: white;
  min-height: 800px;
`
